import { useState, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase';
import { createUserProfile, getUserProfile } from '../services/userService';

export const useUserProfile = () => {
  const [user] = useAuthState(auth);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadUserProfile = async () => {
      if (!user) {
        setUserProfile(null);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        
        // Try to get existing profile
        let profile = await getUserProfile(user.uid);
        
        if (!profile) {
          // Create new profile for first-time users
          profile = await createUserProfile(user);
        }
        
        setUserProfile(profile);
        setError(null);
      } catch (err) {
        console.error('Error loading user profile:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadUserProfile();
  }, [user]);

  const updateProfile = (updates) => {
    setUserProfile(prev => ({ ...prev, ...updates }));
  };

  return {
    user,
    userProfile,
    loading,
    error,
    updateProfile
  };
};
